import React from 'react';

import { PERMISSION } from 'src/features/auth/types';

type AuthContextType = {
    permissions: PERMISSION[];
    permissionsLoaded: boolean;
};

const AuthContext = React.createContext<AuthContextType>({
    permissions: [],
    permissionsLoaded: true,
});

export default AuthContext;
